import { DANGER_COLOR, INFO_COLOR } from 'shared/consts';
import styled from 'styled-components';

export const AlignSelf = styled.div`
	align-self: flex-end;
`;

export const TimeWrapper = styled.div<{ variant?: 'info' | 'danger' }>`
	background: ${props => props.variant === 'danger' ? DANGER_COLOR : INFO_COLOR };
	padding: 2px 4px;
	border-radius: 8px;
	height: 24px;
	width: fit-content;
	position: relative;
	
	&:hover {
        & > .notes {
            opacity: 1;
            visibility: visible;
        }
    }
`;

export const NotesTooltip = styled.div`
	position: absolute;
    padding: 12px;
    right: 0px;
    bottom: 40px;
    background: rgba(161, 170, 198, 1);
    border-radius: 24px;
    color: #fff;
    max-width: 250px;
    width: max-content;
    opacity: 0;
    visibility: hidden;
    transition-duration: .1s;
`;